"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTranslationsConfig = useTranslationsConfig;
var _config = _interopRequireDefault(require("../../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function useTranslationsConfig() {
  var _config$Language;
  var _ref = (_config$Language = _config["default"].Language) !== null && _config$Language !== void 0 ? _config$Language : {
      languageNames: {
        en: 'English'
      },
      enabled: ['en']
    },
    enabled = _ref.enabled,
    languageNames = _ref.languageNames;
  var options = enabled.filter(function (ln) {
    return ln in languageNames;
  }).map(function (lng) {
    return {
      value: lng,
      label: languageNames[lng]
    };
  });
  return {
    languageNames: languageNames,
    options: options
  };
}